export default __webpack_public_path__ + "static/media/Buife_Nomeh_AHV_In_Moms_We_Trust.fbdf0000.jpg";